import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import './Admin.css';

const Admin = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className="admin-container">
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <span className="navbar-brand">Admin Dashboard</span>
          <div className="collapse navbar-collapse justify-content-end">
            <button className="btn btn-outline-danger" onClick={handleLogout}>Logout</button>
          </div>
        </div>
      </nav>
      <div className="d-flex">
        <nav className="sidebar bg-dark">
          <ul className="nav flex-column">
            <li className="nav-item">
                <Link 
                className={`nav-link ${location.pathname === '/admin/activities' ? 'active' : ''}`} 
                to="activities"
              >
                Actividades
              </Link>
            </li>
            <li className="nav-item">
            <Link 
                className={`nav-link ${location.pathname === '/admin/colaboradores' ? 'active' : ''}`} 
                to="colaboradores"
              >
                Colaboradores
              </Link>
            </li>
          </ul>
        </nav>
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Admin;

